import Image from 'next/image';

import { Box, Flex } from '@chakra-ui/react';

import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { Section } from '~/components/section';

import { MentorQualityCard } from './mentor-quality-card';
import { MentorStatsSection, MentorStatsSectionProps } from './mentor-stats-section';

type MentorQualitiesSectionProps = {
  title: string;
  qualities: {
    title: string;
    description: string;
    glyphName: string;
  }[];
  stats: MentorStatsSectionProps['stats'];
};

export function MentorQualitiesSection({ title, qualities, stats }: MentorQualitiesSectionProps) {
  return (
    <Section
      backgroundImage={'linear-gradient(to bottom, accent.sky.100 0%, gray.50 45%)'}
      overflow='hidden'
      position='relative'
    >
      <Box
        display={{ base: 'none', md: 'block' }}
        height='372px'
        left='0px'
        position='absolute'
        top='0px'
        width='272px'
      >
        <Image
          alt=''
          quality={100}
          sizes='272px'
          src='/images/backgrounds/floating-objects-left.svg'
          style={{
            objectFit: 'contain',
            objectPosition: 'left center',
          }}
          fill
        />
      </Box>

      <Box
        display={{ base: 'none', md: 'block' }}
        height='372px'
        position='absolute'
        right='0px'
        top='0px'
        width='272px'
      >
        <Image
          alt=''
          quality={100}
          sizes='272px'
          src='/images/backgrounds/floating-objects-right.svg'
          style={{
            objectFit: 'contain',
            objectPosition: 'right center',
          }}
          fill
        />
      </Box>

      <Box alignItems='center' display='flex' flexDirection='column' justifyContent='center' position='relative'>
        {title && (
          <HeadingWithEmphasis
            text={title}
            emphasisProps={{
              color: 'blue.500',
              fontWeight: 200,
            }}
            headingProps={{
              mb: 6,
              textAlign: 'center',
              whiteSpace: 'pre-wrap',
              size: 'marketing-5xl',
            }}
          />
        )}

        <Flex
          marginTop='56px'
          flexDirection={{
            base: 'column',
            md: 'row',
          }}
          gap={{
            base: '40px',
            md: '80px',
          }}
        >
          {qualities?.map((quality, idx) => (
            <MentorQualityCard
              key={idx}
              description={quality.description}
              glyphName={quality.glyphName}
              title={quality.title}
            />
          ))}
        </Flex>
      </Box>

      <MentorStatsSection stats={stats} />
    </Section>
  );
}
